import { generateUtmExt } from '../../Common/Common';
import axiosInstance from '../../Store/helper/axiosInstance';
import {
  DNR_LANDING_PAGE,
  DNR_HOSPITAL_PROFILE_PAGE_DATA,
  DNR_HOSPITAL_RECOMENDED_POST_DATA,
  DNR_HOSPITAL_GET_ALL_ACTIVITIES_DATA
} from '../QueryKeys/disscussReffer.key';
import { useQuery, useQueryClient, useInfiniteQuery } from 'react-query';

const staleTime = 300000;
const cacheTime = 600000;

export const useDNRlandingPAGE = () => {
  return useQuery(
    DNR_LANDING_PAGE,
    () => axiosInstance.get('referral/fetch_landing_page'),
    {
      refetchOnWindowFocus: false,
      staleTime,
      cacheTime,
      select: (res) => res.data.data
    }
  );
};

export const useDNRhospitalPageData = (id, all_referral) => {
  const queryClient = useQueryClient();
  return useQuery(
    [DNR_HOSPITAL_PROFILE_PAGE_DATA, id, all_referral],
    () =>
      axiosInstance.get(
        `referral/fetch_user_activity?all_referral=${all_referral}&referred_client_master_id=${id}${generateUtmExt()}`
      ),
    {
      cacheTime,
      refetchOnWindowFocus: false,
      select: (res) => res.data.data,
      initialData: () => {
        const hospitalPageFeatured = queryClient
          .getQueryData(DNR_LANDING_PAGE)
          ?.data?.data?.data?.find((h) => h.client_master_id == id);
        console.log('hospitalPageFeatured=====>', hospitalPageFeatured);

        const hospitalPage = hospitalPageFeatured;

        if (hospitalPage) {
          return { data: { data: { client: hospitalPage } } };
          // return { data: { data: hospitalPage } };
        } else {
          return undefined;
        }
      }
    }
  );
};

export const useRecomendedPostList = (id, inView) => {
  return useInfiniteQuery(
    [DNR_HOSPITAL_RECOMENDED_POST_DATA, id],
    ({ pageParam = 0 }) =>
      axiosInstance.get(
        `referral/fetch_recommended_data?referred_client_master_id=${id}&from=${pageParam}&to=5`
      ),
    {
      staleTime: staleTime,
      cacheTime: cacheTime,
      enabled: inView,
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.data?.data?.data?.length == 5) {
          return allPages.length * 5;
        } else {
          return undefined;
        }
      }
    }
  );
};

export const useDNRgetAllActivities = (onSuccess) => {
  return useQuery(
    DNR_HOSPITAL_GET_ALL_ACTIVITIES_DATA,
    () => axiosInstance.get('referral/fetch_user_activity?all_referral=true'),
    {
      cacheTime,
      select: (res) => res.data.data.data,
      onSuccess
    }
  );
};
